import BaseModel from './base-model';

/**
 * format:
 * @COMMON_NAME: "DIRAYA_MACO_MODULO DE ACCESO CENTRALIZADO DE OPERADORES Y PROFESIONALES"
 * @REL_ATTR: "U'A0AE0C235A9E01DE82BF001CC416E56E"
 * @id: "U'A0AE0C235A9E01DE82BF001CC416E56E"
 */
export default class AffectedResource extends BaseModel {
  constructor(opts = {}) {
    super(opts);
    this.id = opts['@id'] || null;
    this.name = opts['@COMMON_NAME'] || null;
  }
}
